import React from 'react';

import SelectBase from 'components/mui/Form/Select/SelectBase';

// TODO: its deprecated component for redux-form, when finish migrate to react-hook-form - remove

const SelectFormLegacy = (props) => {
  const { input, meta, FormControlProps = {}, ...rest } = props;
  const { onChange, value } = input;
  const isError = Boolean(meta.touched && meta.error);

  return (
    <SelectBase
      FormControlProps={{ error: isError, ...FormControlProps }}
      onChange={onChange}
      value={value}
      {...rest}
    />
  );
};

export default SelectFormLegacy;
